module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_charging_solid.717dd9a6.svg";